/**
 * 自定义的工具类
 * @author: wei_wei
 * @date 2022-03-14 11:01:39
 */

/**
 * @functionName sessionData 当用户关闭浏览器窗口后，数据会被删除(数据大小为一般为5MB)。
 * @param {String} method 方式 get(获取) set(先移除后存储) clean(移除) clear(清空)
 * @param {String} name 存储的Key名称 (在这个方法内统一设置存储名称)
 * @param {Object} obj 存储值
 * @returns: NULL
 * @description: 针对 sessionStorage 进行数据存储
 * @author: wei_wei
 * @date 2022-03-14 11:03:50
 * @version: V1.1.2022-03-14_base
 * @modifyContent 修改作者 修改内容:根据改动的大小将版本号进行修改
 */
const sessionData = (method, name, obj) => {
  switch (method) {
    case 'get':
      if (sessionStorage.getItem(`${name}_obj`)) {
        return JSON.parse(sessionStorage.getItem(`${name}_obj`))
      }
      if (sessionStorage.getItem(`${name}_str`)) {
        return sessionStorage.getItem(`${name}_str`)
      }
      return null

    case 'set':
      if (sessionData('clean', name)) {
        if (typeof obj === 'object') {
          sessionStorage.setItem(`${name}_obj`, JSON.stringify(obj))
        } else {
          sessionStorage.setItem(`${name}_str`, obj)
        }
        return true
      }
      return true
    case 'clean':
      sessionStorage.removeItem(`${name}_obj`)
      sessionStorage.removeItem(`${name}_str`)
      return true
    case 'clear':
      sessionStorage.clear()
      return true
  }
}

/**
 * @functionName localData 当用户关手动清除后才会清除，数据会被删除(数据大小为一般为5MB)。
 * @param {String} method 方式 get(获取) set(先移除后存储) clean(移除) clear(清空)
 * @param {String} name 存储的Key名称 (在这个方法内统一设置存储名称)
 * @param {Object} obj 存储值
 * @returns: NULL
 * @description: 针对 localStorage 进行数据存储
 * @author: wei_wei
 * @date 2022-03-14 11:03:50
 * @version: V1.1.2022-03-14_base
 * @modifyContent 修改作者 修改内容:根据改动的大小将版本号进行修改
 */
const localData = (method, name, obj) => {
  switch (method) {
    case 'get':
      if (localStorage.getItem(`${name}_obj`)) {
        return JSON.parse(localStorage.getItem(`${name}_obj`))
      }
      if (localStorage.getItem(`${name}_str`)) {
        return localStorage.getItem(`${name}_str`)
      }
      return null
    case 'set':
      if (localData('clean', name)) {
        if (typeof obj === 'object') {
          localStorage.setItem(`${name}_obj`, JSON.stringify(obj))
        } else {
          localStorage.setItem(`${name}_str`, obj)
        }
        return true
      }
      return true
    case 'clean':
      localStorage.removeItem(`${name}_obj`)
      localStorage.removeItem(`${name}_str`)
      return true
    case 'clear':
      localStorage.clear()
      return true
  }
}

/**
 * @functionName getStorageByKeyList
 * @param {Array} keyList key的集合
 * @param {String} type 类型 sessionStorage或者localStorage 默认localStorage
 * @returns: { key: value, ... }
 * @description: 通过key的集合获取storage存储数据 (获取一批storage存储数据)
 * @author: wei_wei
 * @date 2022-03-14 11:22:42
 * @version: V1.1.2022-03-14_base
 * @modifyContent 修改作者 修改内容:根据改动的大小将版本号进行修改
 */
const getStorageByKeyList = (keyList, type = 'localStorage') => {
  const obj = {}
  for (let i = 0; i < keyList.length; i += 1) {
    const element = keyList[i]
    if (type === 'localStorage') {
      obj[element] = localData('get', element)
    } else {
      obj[element] = sessionData('get', element)
    }
  }
  return obj
}

export default {
  sessionData,
  localData,
  getStorageByKeyList
}



// WEBPACK FOOTER //
// ./src/plugins/custom-util/index.js